import { NavLink } from '../types';

// Exportar imagens centralizadas
export * from './images';

// Configurações do site
export const SITE_CONFIG = {
  name: 'Beyond Class',
  tagline: 'Inglês através de experiências pelo mundo',
  description: 'Aprenda inglês com professores que viveram ao redor do mundo. Suas histórias e vivências são a essência do nosso ensino.',
  email: 'contato@beyondclass.com.br',
  phone: '(81) 99716-0139',
  whatsapp: '5581997160139',
  instagram: '@beyondclass_eas',
  address: 'Recife, PE',
};

// Links de navegação
export const NAV_LINKS: NavLink[] = [
  { label: 'Home', path: '/' },
  { label: 'Nossa Jornada', path: '/sobre' },
  {
    label: 'Experiências',
    path: '/servicos',
    children: [
      { label: 'Aulas Particulares', path: '/servicos/aulas-particulares' },
      { label: 'Imersão ao Ar Livre', path: '/servicos/ar-livre' },
      { label: 'Intercâmbio', path: '/servicos/intercambio' },
      { label: 'Jornada Online', path: '/servicos/cursos-online' },
    ],
  },
  { label: 'Turmas', path: '/turmas' },
  { label: 'Contato', path: '/contato' },
];

// Níveis de inglês
export const ENGLISH_LEVELS = {
  beginner: 'Descobridor',
  intermediate: 'Explorador',
  advanced: 'Aventureiro',
};

// Destinos visitados pelos professores (Easter eggs)
export const DESTINATIONS = [
  { country: 'Irlanda', flag: '🇮🇪', city: 'Dublin', story: 'Poesia na fala' },
  { country: 'Escócia', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', city: 'Edinburgh', story: 'Tradição e história' },
  { country: 'Inglaterra', flag: '🇬🇧', city: 'London', story: 'Berço do idioma' },
  { country: 'Estados Unidos', flag: '🇺🇸', city: 'New York', story: 'Onde tudo começou' },
  { country: 'Canadá', flag: '🇨🇦', city: 'Toronto', story: 'Multiculturalismo' },
  { country: 'Malta', flag: '🇲🇹', city: 'Valletta', story: 'Joia do Mediterrâneo' },
];

// Frases inspiracionais de viagem
export const TRAVEL_QUOTES = [
  { quote: "The world is a book and those who do not travel read only one page.", author: "Saint Augustine" },
  { quote: "To travel is to live.", author: "Hans Christian Andersen" },
  { quote: "Adventure is worthwhile.", author: "Aesop" },
  { quote: "Not all those who wander are lost.", author: "J.R.R. Tolkien" },
];

// Cores do tema (terrosos)
export const THEME_COLORS = {
  primary: '#b08d5b', // earth-500
  secondary: '#e2684e', // terracotta-500
  accent: '#8a995d', // olive-500
  dark: '#2d1f16', // earth-950
  light: '#fdf8f3', // earth-50
  passport: '#3a635e', // passport-500
};
